import { MutableRefObject } from 'react'
import { create } from 'zustand'

interface ModalStoreType {
  modalRef: React.MutableRefObject<HTMLDivElement | null>
  editMode: boolean
  libraryImportModal: boolean
  libraryDeleteModal: boolean
  libraryMultipleSearchModal: boolean
  extractedTextViewModal: boolean
  exportDatasetModal: boolean
  projectCreateModal: boolean
  projectCopyModal: boolean
  projectDeleteModal: boolean
  reportModalType: '' | 'createFolder' | 'createReport' | 'editFolder' | 'editReport'
  reportEditDetailsModal: boolean
  clipboardStepModal: boolean
  dataSourceModal: boolean
  connectorModal: boolean
  groupModal: boolean
  userModal: boolean
  libraryEditDetailsModal: boolean
  projectEditDetailsModal: boolean
  apfDetailModal: boolean
  domainModal: boolean
  apfEditDetailsModal: boolean
  isUnsavedStepCopyMode: boolean
  setEditMode: (value: boolean) => void
  setLibraryImportModal: (visible: boolean) => void
  setLibraryDeleteModal: (visible: boolean) => void
  setLibraryMultipleSearchModal: (visible: boolean) => void
  setExtractedTextViewModal: (visible: boolean) => void
  setExportDatasetModal: (visible: boolean) => void
  setProjectCreateModal: (visible: boolean) => void
  setProjectDeleteModal: (visible: boolean) => void
  setProjectCopyModal: (visible: boolean) => void
  setReportModalType: (
    type: '' | 'createFolder' | 'createReport' | 'editFolder' | 'editReport'
  ) => void
  setReportEditDetailsModal: (visible: boolean) => void
  setClipboardStepModal: (visible: boolean, isUnsavedStepCopyMode?: boolean) => void
  setDatasourceModal: (visible: boolean) => void
  setConnectorModal: (visible: boolean) => void
  setGroupModal: (visible: boolean) => void
  setUserModal: (visible: boolean) => void
  setLibraryEditDetailsModal: (visible: boolean) => void
  setProjectEditDetailsModal: (visible: boolean) => void
  setApfDetailModal: (visible: boolean) => void
  setDomainModal: (visible: boolean) => void
  setApfEditDetailsModal: (visible: boolean) => void
}

const useModalStore = create<ModalStoreType>((set) => ({
  modalRef: { current: null } as MutableRefObject<HTMLDivElement | null>,
  editMode: false,
  libraryImportModal: false,
  libraryDeleteModal: false,
  libraryMultipleSearchModal: false,
  extractedTextViewModal: false,
  exportDatasetModal: false,
  projectCreateModal: false,
  projectCopyModal: false,
  projectDeleteModal: false,
  reportModalType: 'createReport',
  reportEditDetailsModal: false,
  clipboardStepModal: false,
  dataSourceModal: false,
  connectorModal: false,
  groupModal: false,
  userModal: false,
  libraryEditDetailsModal: false,
  projectEditDetailsModal: false,
  apfDetailModal: false,
  domainModal: false,
  apfEditDetailsModal: false,
  isUnsavedStepCopyMode: false,
  setEditMode: (value: boolean) => {
    set((state) => ({ ...state, editMode: value }))
  },
  setLibraryImportModal: (visible: boolean) => {
    set((state) => ({ ...state, libraryImportModal: visible }))
  },
  setExportDatasetModal: (visible: boolean) => {
    set((state) => ({ ...state, exportDatasetModal: visible }))
  },
  setLibraryDeleteModal: (visible: boolean) => {
    set((state) => ({ ...state, libraryDeleteModal: visible }))
  },
  setLibraryMultipleSearchModal: (visible: boolean) => {
    set((state) => ({ ...state, libraryMultipleSearchModal: visible }))
  },
  setExtractedTextViewModal: (visible: boolean) => {
    set((state) => ({ ...state, extractedTextViewModal: visible }))
  },
  setProjectCreateModal: (visible: boolean) => {
    set((state) => ({ ...state, projectCreateModal: visible }))
  },
  setProjectDeleteModal: (visible: boolean) => {
    set((state) => ({ ...state, projectDeleteModal: visible }))
  },
  setProjectCopyModal: (visible: boolean) => {
    set((state) => ({ ...state, projectCopyModal: visible }))
  },
  setReportModalType: (
    type: '' | 'createFolder' | 'createReport' | 'editFolder' | 'editReport'
  ) => {
    set((state) => ({ ...state, reportModalType: type }))
  },
  setReportEditDetailsModal: (visible: boolean) => {
    set((state) => ({ ...state, reportEditDetailsModal: visible }))
  },
  setClipboardStepModal: (visible: boolean, isUnsavedStepCopyMode?: boolean) => {
    set((state) => ({
      ...state,
      clipboardStepModal: visible,
      isUnsavedStepCopyMode: isUnsavedStepCopyMode ?? false,
    }))
  },
  setDatasourceModal: (visible: boolean) => {
    set((state) => ({ ...state, dataSourceModal: visible }))
  },
  setConnectorModal: (visible: boolean) => {
    set((state) => ({ ...state, connectorModal: visible }))
  },
  setGroupModal: (visible: boolean) => {
    set((state) => ({ ...state, groupModal: visible }))
  },
  setUserModal: (visible: boolean) => {
    set((state) => ({ ...state, userModal: visible }))
  },
  setLibraryEditDetailsModal: (visible: boolean) => {
    set((state) => ({ ...state, libraryEditDetailsModal: visible }))
  },
  setProjectEditDetailsModal: (visible: boolean) => {
    set((state) => ({ ...state, projectEditDetailsModal: visible }))
  },
  setApfDetailModal: (visible: boolean) => {
    set((state) => ({ ...state, apfDetailModal: visible }))
  },

  setDomainModal: (visible: boolean) => {
    set((state) => ({ ...state, domainModal: visible }))
  },
  setApfEditDetailsModal: (visible: boolean) => {
    set((state) => ({ ...state, apfEditDetailsModal: visible }))
  },
}))

export default useModalStore
